import { render, staticRenderFns } from "./FeatureBadge.vue?vue&type=template&id=f1456c2a"
import script from "./FeatureBadge.vue?vue&type=script&lang=js"
export * from "./FeatureBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports